// Lightweight ModelExecutionResponse entity wrapper with PascalCase fields only
export default class ModelExecutionResponse {
  constructor(data) {
    // Expect data to have PascalCase fields (Output, SignalFilePath, ExecutionDuration, SignalFileId)
    this.Output = data.Output;
    this.SignalFilePath = data.SignalFilePath;
    this.ExecutionDuration = data.ExecutionDuration;
    this.SignalFileId = data.SignalFileId;
  }

  // Helper method to format execution duration
  getFormattedExecutionDuration() {
    if (!this.ExecutionDuration) return '';

    // If ExecutionDuration is a TimeSpan string like "00:00:30.1234567"
    if (typeof this.ExecutionDuration === 'string') {
      const parts = this.ExecutionDuration.split(':');
      if (parts.length >= 3) {
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const secondsPart = parseFloat(parts[2]);
        const seconds = Math.floor(secondsPart);
        const milliseconds = Math.round((secondsPart - seconds) * 1000);

        if (hours > 0) {
          return `${hours}h ${minutes}m ${seconds}s`;
        } else if (minutes > 0) {
          return `${minutes}m ${seconds}s`;
        } else if (seconds > 0) {
          return `${seconds}.${milliseconds.toString().padStart(3, '0')}s`;
        } else {
          return `${milliseconds}ms`;
        }
      }
    }

    // If ExecutionDuration is a number (milliseconds)
    if (typeof this.ExecutionDuration === 'number') {
      const totalMs = this.ExecutionDuration;
      const hours = Math.floor(totalMs / (1000 * 60 * 60));
      const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((totalMs % (1000 * 60)) / 1000);
      const milliseconds = totalMs % 1000;

      if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
      } else if (seconds > 0) {
        return `${seconds}.${milliseconds.toString().padStart(3, '0')}s`;
      } else {
        return `${milliseconds}ms`;
      }
    }

    return this.ExecutionDuration.toString();
  }

  // Check if output is available
  hasOutput() {
    return this.Output && this.Output.trim().length > 0;
  }

  // Get trimmed output for display
  getTrimmedOutput(maxLength = 500) {
    if (!this.hasOutput()) return '';

    const output = this.Output.trim();
    if (output.length <= maxLength) return output;

    return output.substring(0, maxLength) + '...';
  }
}
